<template>
  <!-- SPACER DIV OF SPECIFIED HEIGHT -->
  <div :style="`height: ${element.verticalGap * scaleFactor}px`" class="w-full">
  </div>
</template>

<script>
// import Component from "../component_location"

export default {
  components: {},

  props: {
    element: { type: Object, default: () => {} },
    scaleFactor: { type: Number, default: 1 },
  },

  data() {
    return {};
  },

  watch: {},

  methods: {},

  computed: {},

  mounted() {},
};
</script>

<style>
.downscale {
  transform: scale(0.7, 0.7);
  transform-origin: top left;
}
</style>
